module.exports = __webpack_public_path__ + "static/img/a108.c25dbaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a108.jpg
// module id = Mmb/
// module chunks = 0